import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Cookie } from "lucide-react";
import { useLang } from "../i18n";

export default function CookieBanner() {
  const { t } = useLang();
  const [choice, setChoice] = useState(() => localStorage.getItem("ustp-cookie-consent") || "");

  const decide = (v) => {
    localStorage.setItem("ustp-cookie-consent", v);
    setChoice(v);
  };

  return (
    <AnimatePresence>
      {!choice && (
        <motion.div
          initial={{ y: 140, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 140, opacity: 0 }}
          transition={{ duration: 0.55, ease: [0.22, 1, 0.36, 1] }}
          data-testid="cookie-banner"
          className="fixed bottom-4 left-4 right-4 sm:left-auto sm:right-6 sm:w-[380px] z-[70] rounded-3xl border border-slate-200 bg-white/95 backdrop-blur-xl p-5 shadow-2xl shadow-slate-900/20"
        >
          <div className="flex gap-3">
            <Cookie size={20} className="shrink-0 text-sky-600" />
            <p className="text-xs text-slate-600 leading-relaxed">
              {t.cookie.text}{" "}
              <a
                href="/cookie"
                data-testid="cookie-policy-link"
                className="font-semibold text-sky-700 underline underline-offset-2 hover:text-sky-600"
              >
                {t.cookie.policyLink}
              </a>
              .
            </p>
          </div>
          <div className="mt-4 flex gap-3">
            <button
              onClick={() => decide("accepted")}
              data-testid="cookie-accept"
              className="flex-1 rounded-full bg-slate-900 px-4 py-2 text-sm font-semibold text-white hover:bg-sky-600 transition-colors"
            >
              {t.cookie.accept}
            </button>
            <button
              onClick={() => decide("refused")}
              data-testid="cookie-decline"
              className="flex-1 rounded-full border border-slate-300 px-4 py-2 text-sm font-semibold text-slate-700 hover:border-sky-400 transition-colors"
            >
              {t.cookie.refuse}
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
